import openPlatformApplication from "../open-platform.json";

export interface ClientConfig {
  readonly apiBaseUrl: string;
  readonly oidcClientId: string;
  readonly oidcIssuer: string;
}

/** Public endpoints only; tokens and secrets are never part of the Pages bundle. */
export const clientConfig: ClientConfig = {
  apiBaseUrl: import.meta.env.VITE_IM_API_URL ?? openPlatformApplication.apiBaseUrl,
  oidcClientId: import.meta.env.VITE_OIDC_CLIENT_ID ?? openPlatformApplication.clientId,
  oidcIssuer: import.meta.env.VITE_OIDC_ISSUER ?? openPlatformApplication.oidcIssuer,
};
